/* eslint-disable import/order */
import workflowsResource from '@jira/admin-pages__list-workflows/src/workFlowsResource.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueWorkflow1Route } from '@jira/router-routes__admin-pages-workflows-routes/src/globalSettingsIssueWorkflow1Route.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import ListWorkflows, {
	LazyListWorkflows,
} from './ui/spa/admin-pages/workflows/list-workflows/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsIssueWorkflow1RouteEntry: Route = createEntry(
	globalSettingsIssueWorkflow1Route,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.view-workflows',
		// eslint-disable-next-line no-restricted-syntax
		component: ListWorkflows,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			workflowsResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyListWorkflows],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
